/**
 * Phase 11 — Invoice Number Display Formatting
 *
 * The stored `invoice_number` is neutral and prefix-free (e.g. "2026-0042").
 * The display prefix is derived from `document_kind` at render time.
 *
 * Rule: An EST- prefix never leaks onto a finalized invoice. Once
 * `document_kind` flips from 'estimate' to 'invoice' on finalize, the
 * displayed identifier becomes INV-2026-0042 — same record, same number,
 * no renumbering.
 */

export type DocumentKind = 'estimate' | 'invoice';

export function formatInvoiceNumber(args: {
  invoice_number: string | null | undefined;
  document_kind: DocumentKind | string | null | undefined;
}): string {
  const num = (args.invoice_number ?? '').trim();
  if (!num) return '';
  const prefix = args.document_kind === 'invoice' ? 'INV' : 'EST';
  return `${prefix}-${num}`;
}

export function documentKindLabel(kind: DocumentKind | string | null | undefined): string {
  return kind === 'invoice' ? 'Invoice' : 'Estimate';
}

export function documentKindUpperLabel(kind: DocumentKind | string | null | undefined): string {
  return kind === 'invoice' ? 'INVOICE' : 'ESTIMATE';
}
